<div class="css-Snippet_Empresa-1 snippet_empresa">
    <div class="css-Radio_Snippet_empresa-1 radio_snippet_empresa"
        [ngStyle]="{ display: permiteSeleccionar ? '' : 'none' }">
        <input id="input_radio_radiobutton_empresa_{{idEmpresa}}" type="radio"
            class="css-input_radio_Radiobutton_empresa-1 input_radio_radiobutton_empresa" name="comp_snippet_empresa"
            (change)="onSeleccionar()" [checked]="!permiteSeleccionar">
    </div>
    <div class="css-Contenido_empresa-1 contenido_empresa">
        <div class="css-Nombre_empresa-1 nombre_empresa">
            <label id="label_radiobutton_empresa_{{idEmpresa}}"
                class="css-label_Radiobutton_empresa-1 label_radiobutton_empresa"
                for="input_radio_radiobutton_empresa_{{idEmpresa}}">{{empresaItem.nombre}}</label>
        </div>
        <div class="css-Datos_empresa-1 datos_empresa">
            <div class="css-NoContribuyente_empresa-1 nocontribuyente_empresa">
                <div class="css-Cont_Etiqueta_NoContribuyente-1 cont_etiqueta_nocontribuyente">
                    <p class="css-Etiqueta_NoContribuyente-1 etiqueta_nocontribuyente">N° Contrib.:</p>
                </div>
                <div class="css-Cont_Dato_NoContribuyente-1 cont_dato_nocontribuyente">
                    <p class="css-Dato_NoContribuyente-1 dato_nocontribuyente">
                        {{empresaItem.nroContribuyente}}</p>
                </div>
            </div>
            <div class="css-NoEmpresa_empresa-1 noempresa_empresa">
                <div class="css-Cont_Etiqueta_NoEmpresa-1 cont_etiqueta_noempresa">
                    <p class="css-Etiqueta_NoEmpresa-1 etiqueta_noempresa">N° Empresa:
                    </p>
                </div>
                <div class="css-Cont_Dato_NoEmpresa-1 cont_dato_noempresa">
                    <p class="css-Dato_NoEmpresa-1 dato_noempresa">{{empresaItem.nroEmpresa}}</p>
                </div>
            </div>
            <div class="css-Aportacion_empresa-1 aportacion_empresa">
                <div class="css-Cont_Etiqueta_Aportacion-1 cont_etiqueta_aportacion">
                    <p class="css-Etiqueta_Aportacion-1 etiqueta_aportacion">
                        Aportación:</p>
                </div>
                <div class="css-Cont_Dato_Aportacion-1 cont_dato_aportacion">
                    <p class="css-Dato_Aportacion-1 dato_aportacion">{{empresaItem.descripcionAportacion}}
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>